import React from 'react'
import AccordionSuggestion from 'ui-shared/accordions/AccordionSuggestion'
import KAccordion from 'ui-shared/accordions/KAccordion'
import DefaultQuantityHint from './DefaultQuantityHint'
import QuantityHintArrayInput from './QuantityHintArrayInput'
import QuantityHintGuestMockField from './QuantityHintGuestMockField'
import ContentToggler from 'ui-shared/ContentToggler'
import { WithQuantityHint } from '../types'
import { useWatch } from 'react-hook-form'

type Props = {
  accordionText: string[]
}

const QuantityHintForm: React.FC<Props> = ({ accordionText, ...props }) => {
  const guestsNumberMock = useWatch<WithQuantityHint, 'guestsNumberMock'>({
    name: 'guestsNumberMock',
  })
  const quantityHint = useWatch<WithQuantityHint, 'quantityHint'>({
    name: 'quantityHint',
  })

  return (
    <KAccordion accordionTitle="Quantity">
      <ContentToggler
        {...props}
        source="showQuantityHint"
        label="form.fields.showQuantityHint"
      >
        <QuantityHintArrayInput
          guestsNumberMock={guestsNumberMock}
          quantityHint={quantityHint}
        />
        <DefaultQuantityHint
          guestsNumberMock={guestsNumberMock}
          quantityHint={quantityHint}
        />
        <QuantityHintGuestMockField />
      </ContentToggler>
      <AccordionSuggestion
        accordionText={accordionText}
        accordionTitle="form.fields.howItWorks"
      />
    </KAccordion>
  )
}

export default QuantityHintForm
